import type { Workbook, Worksheet } from 'exceljs';

export async function createExcelWorkbook(): Promise<Workbook> {
  const { default: ExcelJS } = await import('exceljs');
  return new ExcelJS.Workbook();
}

export function addRecordWorksheet(workbook: Workbook, name: string, records: Array<Record<string, unknown>>): Worksheet {
  const worksheet = workbook.addWorksheet(name);
  const headers = Array.from(new Set(records.flatMap(record => Object.keys(record))));
  if (headers.length > 0) {
    worksheet.addRow(headers);
    records.forEach(record => worksheet.addRow(headers.map(header => record[header] ?? null)));
  }
  return worksheet;
}

export function setExcelColumnWidths(worksheet: Worksheet, characterWidths: number[]): void {
  characterWidths.forEach((width, index) => {
    worksheet.getColumn(index + 1).width = Math.round((width + 5 / 6) * 256) / 256;
  });
}

export async function downloadExcelWorkbook(workbook: Workbook, fileName: string): Promise<void> {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([new Uint8Array(buffer)], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  try {
    document.body.appendChild(anchor);
    anchor.click();
  } finally {
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}